import { render } from "./createOutBill.vue?vue&type=template&id=18cfafe4&scoped=true&ts=true"
import script from "./createOutBill.vue?vue&type=script&lang=ts"
export * from "./createOutBill.vue?vue&type=script&lang=ts"

import "./createOutBill.vue?vue&type=style&index=0&id=18cfafe4&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18cfafe4"]])

export default __exports__